import { Button, useDisclosure } from '@nextui-org/react'
import { useEffect } from 'react'
import useHomeUpdateStore from '../../store/home/useHomeUpdateStore'
import { InitialInfo } from './InitialInfo'
import { SelectTanksUpdate } from './SelectTanksUpdate'

export const UpdateCTA = () => {
  const { isOpen: isOpen1, onOpen: onOpen1, onOpenChange: onOpenChange1 } = useDisclosure()
  const { isOpen: isOpen2, onOpen: onOpen2, onOpenChange: onOpenChange2 } = useDisclosure()
  const { reset } = useHomeUpdateStore()

  useEffect(() => {
    if (!isOpen1 && !isOpen2) {
      reset()
    }
  }, [isOpen1, isOpen2, reset])

  return (
    <>
      <div className="fixed bottom-16 right-2 z-30 md:hidden" style={{ pointerEvents: 'auto' }}>
        <Button
          onPress={onOpen1}
          className="font-bold bg-tdplprussian text-tdplbisque mx-2 text-[1rem] hover:bg-tdpllightgrey hover:text-tdplindigo transition-colors duration-200 data-[disabled=true]:text-gray-500"
          size="lg"
          data-testid="update-cta-button"
        >
          Update
        </Button>
      </div>

      <SelectTanksUpdate isOpen={isOpen1} onOpenChange={onOpenChange1} onOpen={onOpen2} />
      <InitialInfo onOpenChange={onOpenChange2} isOpen={isOpen2} isBack={onOpen1} />
    </>
  )
}
